import React from "react";
import ToggleBar from "../../commoncomponents/toggleBar";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
function RealTimeSpeed(props) {
  const dictionarySelection = (value) => {
    return props.speedObj[value];
  };
  const options = {
    title: {
      text: "",
    },
      tooltip: {
        formatter: function () {
            return this.points.reduce(function (s, point) {
                return s + '<br/>' + point.series.name + ': <b>' +
                    point.y + 'Kph</b>';
            }, '<b>' + dictionarySelection(this.x) + '</b>');
        },
        shared: true
    },
    xAxis: {
      type: "datetime",
      tickInterval: 3600 * 1000,
    },
    series: [
      {
        type: "line",
        data: props.sData,
        name: "Speed",
        color: "#90ED7D",
        marker: {
          symbol: "diamond",
        },
      },
    ],
  };
  const data = <HighchartsReact highcharts={Highcharts} options={options} />;

  return (
    <ToggleBar
      caption="Realtime Speed"
      // download={handleDownloadExcel}
      icon="fa-building"
      color="#337ab7"
      content={data}
    />
  );
}

export default RealTimeSpeed;
